import TranslateApi from "src/utils/TranslateHelper";
import bindAllOfThis from "src/utils/BindThisHelper";
import { PhaserModalConfig, PhaserModal } from "src/games/shared/Modal";
import { Envelope, EnvelopeInfo } from "src/games/MailDeliveryGame/objects/Envelope";
import { Slot, SlotConfig } from "../objects/Slot";
import { EndGameScene } from "src/games/MailDeliveryGame/scenes/EndGameScene";
import { TiledGameObject } from "../../shared/phaserHelpers/HandyTypes";
import { House, HouseInfo } from "src/games/MailDeliveryGame/objects/House";

export class SortScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    goButton: Phaser.GameObjects.Image;
    envelopes: Envelope[];
    map: Phaser.Tilemaps.Tilemap;
    slots: Slot[];
    tray: Phaser.GameObjects.Image;
    truck: Phaser.GameObjects.Sprite;
    addressLabels: Phaser.GameObjects.Sprite[];
    points: Phaser.Math.Vector2[];
    index: number;
    follower: Phaser.GameObjects.PathFollower;
    houses: Phaser.GameObjects.Zone[];

    constructor() {
        super({
            key: "GameScene"
        });

        bindAllOfThis(this, SortScene.prototype);
    }

    preload(): void {
        this.load.image('background', require("/src/assets/qci/backgrounds/2c_background.png"));
        this.load.tilemapTiledJSON("map", require("/src/assets/qci/maps/2c_mail_delivery.json"));
        this.load.atlas("assets", require("/src/assets/qci/atlas/gameMailDelivery.png"), require("/src/assets/qci/atlas/gameMailDelivery.json"));

        this.load.spritesheet("truck", require("src/assets/qci/sprites/gameMailDelivery/truck.png"), {
            frameWidth: 100,
            frameHeight: 75
        });
        this.load.spritesheet("button", require("src/assets/qci/sprites/gameMailDelivery/go_button.png"), {
            frameWidth: 150,
            frameHeight: 150
        });
        this.load.spritesheet("address", require("src/assets/qci/sprites/gameMailDelivery/addresses.png"), {
            frameWidth: 228,
            frameHeight: 60
        });

    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;

        this.map = this.make.tilemap({ key: "map" });
        this.envelopes = [];
        this.slots = [];
        this.addressLabels = [];
        this.houses = [];
    }

    create(): void {
        this.initialize();
        this.addObjects();
        this.registerEvents();
    }

    addObjects() {
        var background = this.add.image(0, 0, "background");
        background.setOrigin(0);
        var crater_house;

        this.map.getObjectLayer("Layout").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "go") {
                var panel = this.add.image(ob.x, ob.y, "assets", "button_panel");
                panel.setOrigin(0);
                var center = panel.getCenter();

                this.goButton = this.add.sprite(center.x, center.y, "button");
                this.goButton.setFrame(0); // Purple button
                this.goButton.setInteractive();
                this.goButton.on("pointerdown", () => {
                    this.checkEnvelopes();
                });
            }
            else if (ob.name === "tray") {
                this.tray = this.add.image(ob.x, ob.y, "pixel");
                this.tray.setOrigin(0);
                this.tray.setTint(0x000000);
                this.tray.setAlpha(0.8);
                this.tray.setDisplaySize(ob.width, ob.height);
                this.addSlots();
                this.addEnvelopes();
            }
            else if (ob.name === "truck") {
                this.truck = this.add.sprite(ob.x, ob.y, "truck", 4);
                this.truck.setOrigin(0);
            }
            else if (ob.name === "house") {
                crater_house = this.add.image(ob.x, ob.y, "assets", "crater_house");
                crater_house.setOrigin(0);
                crater_house.setDepth(10);
            }
            else if (ob.name === "path") {
                var json = require("../objects/path.json");
                this.points = json["path"];
                this.points.forEach((p) => {
                    p.x += ob.x;
                    p.y += ob.y;
                });
            }
        });

        this.addHouseZones();
    }

    addHouseZones() {
        this.map.getObjectLayer("Houses").objects.forEach((ob: TiledGameObject) => {
            var info = House.Houses.find((h: HouseInfo) => h.id === parseInt(ob.name));
            // For whatever reason..not able to use the House class which extends Zone...so just use normal zones
            var house = this.add.zone(ob.x, ob.y, ob.width, ob.height);
            house.setOrigin(0);
            house.setInteractive();

            var label = this.add.sprite(ob.x, ob.y, "address", info.frame);
            label.type = "label";
            label.name = info.id + "";
            label.setPosition(Math.min(ob.x + label.width / 2, this.gameWidth - label.width / 2 - 10));
            label.setY(ob.y - label.height / 2);
            label.setVisible(false);
            this.addressLabels.push(label);

            // Clicking a house shows/hides it's address label
            house.on("pointerdown", () => {
                label.visible = !label.visible;
                // Hide all other labels
                this.addressLabels.forEach((l) => {
                    if (l.name !== label.name) {
                        l.setVisible(false);
                    }
                });
            });

            this.houses.push(house);
        });
    }

    addEnvelopes() {
        var slots = [...this.slots];
        Envelope.Envelopes.forEach((info: EnvelopeInfo) => {
            var slot = slots.pop();
            var envelope = new Envelope(this, 0, 0, info);
            envelope.x = slot.x;
            envelope.y = slot.y;
            slot.envelopeId = envelope.id;
            this.envelopes.push(envelope);
        });
    }

    addSlots() {
        var slotWidth = 175;
        var slotHeight = 125;
        Slot.Slots.forEach((config: SlotConfig) => {
            var slot = new Slot(this, 0, 0, slotWidth, slotHeight, config);
            this.slots.push(slot);
        });

        Phaser.Actions.GridAlign(this.slots, {
            x: 200,
            y: slotHeight / 2 + 15,
            width: 4,
            height: 2,
            cellWidth: slotWidth + 25,
            cellHeight: slotHeight + 10,
        });

        var style = {
            fontSize: 30,
            fontFamily: "Russo One, Arial",
            align: "center"
        };

        this.slots.forEach((s) => {
            this.add.graphics().lineStyle(3, 0x000000).strokeRectShape(s.getBounds());
            var number = this.add.text(0, 0, (s.id + 1) + "", style);
            Phaser.Display.Align.In.Center(number, s);
        });
    }

    registerEvents() {
        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, envelope: Envelope) => {
            // Restrict to the tray
            if ((pointer.y > (this.tray.getBottomRight().y - 20)) || (pointer.x > 1050)) {
                return;
            }
            envelope.x = pointer.downX;
            envelope.y = pointer.downY;
            this.children.bringToTop(envelope);
            envelope.setScale(0.8);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, envelope: Envelope, dragX: number, dragY: number) => {
            // Restrict to the tray
            if ((pointer.y > (this.tray.getBottomRight().y - 20)) || (pointer.x > 1050)) {
                return;
            }
            envelope.x = pointer.x;
            envelope.y = pointer.y - 20;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, envelope: Envelope, dropped: boolean) => {
            this.children.moveDown(envelope);
        });

        this.input.on('drop', (pointer, envelope: Envelope, slot: Slot) => {
            if (!this.inTray(envelope)) {
                return;
            }
            this.dropEnvelope(envelope, slot);
        });
    }

    dropEnvelope(envelope: Envelope, slot: Slot) {
        // Slot is filled already, don't assign it
        if (this.isSlotFilled(slot, envelope)) {
            return;
        }

        // Snap envelope to center
        envelope.x = slot.x;
        envelope.y = slot.y;

        slot.envelopeId = envelope.id;
        envelope.setScale(1);
    }

    /**
     * Checks if the slot contains any of the envelopes by using rectangle/bounds
     * Don't include the envelope you're currently trying to drop in (otherwise it would always return true)
     */
    isSlotFilled(slot: Slot, currentEnvelope: Envelope) {
        var envelope: Envelope;
        for (envelope of this.envelopes) {
            if (envelope.id !== currentEnvelope.id && Phaser.Geom.Rectangle.ContainsPoint(slot.getBounds(), envelope.getCenter())) {
                return true;
            }
        }

        return false;
    }

    checkEnvelopes() {
        var slot: Slot;
        var open = 0;
        var incorrect = 0;
        for (slot of this.slots) {
            if (slot.correctEnvelopeId !== slot.envelopeId) {
                incorrect++;
            }
            // Check that the slot's assigned envelope is actually inside the slot, if not, it's not "locked" (it's open)
            var envelope = this.envelopes.find((e: Envelope) => e.id === slot.envelopeId);
            if (!Phaser.Geom.Rectangle.ContainsPoint(slot.getBounds(), envelope.getCenter())) {
                open++;
            }
        }

        // Prioritize by only first caring if they didn't get all the envelopes
        if (open > 0) {
            this.modalPop("notDone", false);
            return;
        }
        // Then tell them if they got any wrong
        if (incorrect > 0) {
            this.modalPop("incorrect", false);
            return;
        }
        // Otherwise, good to go
        this.moveTruck();
    }

    modalPop(key: string, gameover?: boolean): void {
        var config = new PhaserModalConfig();
        config.title = TranslateApi.translate("MailDelivery.Phaser." + key);
        config.buttonConfig.smartSize = true;
        var modal = new PhaserModal(this, 0, 0, [{ id: 1, displayText: TranslateApi.translate("common.ok") }], config);
        modal.setDepth(12);
        modal.setPosition(this.gameWidth / 2 - modal.width / 2, this.gameHeight / 2 - modal.height / 2);
        modal.on('optionClicked', () => {
            modal.destroy();
            if (gameover) {
                this.input.setDefaultCursor("default");
                this.input.removeAllListeners();
                this.scene.add("EndGameScene", EndGameScene, true);
                this.scene.remove(this);
            }
        });
    }

    inTray(envelope: Envelope) {
        return Phaser.Geom.Intersects.RectangleToRectangle(this.tray.getBounds(), envelope.getBounds());
    }

    /**
    * Shuffle the slots so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    randomizeSlots(slots) {
        var j, x, i;
        for (i = slots.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = slots[i];
            slots[i] = slots[j];
            slots[j] = x;
        }

        return slots;
    }

    isCorrectOrder(slots) {
        var correctOrder = [];
        var sorted = this.slots.sort((s1: Slot, s2: Slot) => s1.id - s2.id);
        sorted.forEach((s: Slot) => correctOrder.push(s.id));

        for (var i = 0; i < correctOrder.length; i++) {
            if (correctOrder[i] !== slots[i].id) {
                return false;
            }
        }
        return true;
    }

    moveTruck() {
        // Hide all address labels
        this.addressLabels.forEach((l) => {
            l.setVisible(false);
        });

        this.goButton.setFrame(1); // Green
        var truckPath = new Phaser.Curves.Path(this.truck.x + this.truck.width / 2, this.truck.y + this.truck.height / 2);
        truckPath.splineTo(this.points);

        this.follower = this.add.follower(truckPath, this.truck.x + this.truck.width / 2, this.truck.y + this.truck.height / 2, "truck", 4);
        this.follower.setDepth(8);
        this.truck.setVisible(false);
        this.follower.startFollow({
            duration: 14000,
        } as PathConfig);
        this.follower.stopFollow();

        this.anims.create({
            key: "path",
            frames: [
                { key: "truck", frame: 4, duration: 1800 }, // RIGHT

                // Turn 1
                { key: "truck", frame: 2 }, // RIGHT BACK
                { key: "truck", frame: 1 }, // BACK
                { key: "truck", frame: 0 }, // LEFT BACK
                { key: "truck", frame: 3, duration: 700 }, // LEFT

                // Turn 2
                { key: "truck", frame: 0 }, // LEFT BACK
                { key: "truck", frame: 1 }, // BACK
                { key: "truck", frame: 2, duration: 500 }, // RIGHT BACK

                // Turn 3
                { key: "truck", frame: 2 }, // RIGHT BACK
                { key: "truck", frame: 1 }, // BACK
                { key: "truck", frame: 0 }, // LEFT BACK

                { key: "truck", frame: 3, duration: 3900 }, // LEFT

                // Turn 4
                { key: "truck", frame: 5 }, // LEFT FRONT
                { key: "truck", frame: 6 },  // FRONT
                { key: "truck", frame: 7, duration: 500 }, // RIGHT FRONT

                // Turn 5
                { key: "truck", frame: 4, duration: 400 }, // RIGHT
                { key: "truck", frame: 7 }, // RIGHT FRONT
                { key: "truck", frame: 6 }, // FRONT
                { key: "truck", frame: 5 }, // LEFT FRONT
                { key: "truck", frame: 3, duration: 600 }, // LEFT

                // Turn 6
                { key: "truck", frame: 6 }, // FRONT
                { key: "truck", frame: 7 }, // RIGHT FRONT

                { key: "truck", frame: 4, duration: 1100 }, // RIGHT

            ],
            frameRate: 8,
        });

        this.anims.play("path", this.follower);

        this.goButton.disableInteractive();
        this.input.removeAllListeners();
        this.envelopes.forEach((e) => e.removeInteractive());
        this.houses.forEach((h) => h.removeInteractive());

        this.follower.on("animationcomplete", () => {
            // For some reason the animation completes a little early, so wait until the truck stops moving to show them the modal
            setTimeout(() => {
                this.modalPop("deliveredAll", true);
            }, 1700);
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/MailDeliveryGame/scenes/SortScene.ts